module.exports = __webpack_public_path__ + "r-v3/img/star.b432f36b.svg";